export interface PendingRedirect {
  path: string;
  state?: any;
}

const PENDING_REDIRECT_KEY = 'pending_game_redirect';

export const setPendingGameRedirect = (redirect: PendingRedirect): void => {
  try {
    sessionStorage.setItem(PENDING_REDIRECT_KEY, JSON.stringify(redirect));
  } catch (e) {
    // Ignore sessionStorage errors
  }
};

export const getAndClearPendingGameRedirect = (): PendingRedirect | null => {
  try {
    const raw = sessionStorage.getItem(PENDING_REDIRECT_KEY);
    if (raw) {
      sessionStorage.removeItem(PENDING_REDIRECT_KEY);
      return JSON.parse(raw);
    }
  } catch (e) {
    // Ignore parse/storage errors
  }
  return null;
};
